export const ACTION_TYPES = {
    // loadingSpinner
    START_LOADING: 'START_LOADING',
    STOP_LOADING: 'STOP_LOADING',
    CLEAR_LOADING: 'CLEAR_LOADING',
    SET_LOADING_MSG: 'SET_LOADING_MSG',

    // snackBar
    SHOW_SNACKBAR: 'SHOW_SNACKBAR',
    HIDE_SNACKBAR: 'HIDE_SNACKBAR',

    // Files
    SAVE_FILE: 'SAVE_FILE',
    GET_FILE: 'GET_FILE',
    DELETE_FILE: 'DELETE_FILE',

    // API
    CALL_API: 'CALL_API',
    UPLOAD_FILE: 'UPLOAD_FILE',

    // Account
    AUTHENTICATE_TEAMNOTE_JWT: 'AUTHENTICATE_TEAMNOTE_JWT',
    SET_ME: 'SET_ME',
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    GET_ME: 'GET_ME',

    //// Room Booking

    // Locations
    GET_LOCATIONS: 'GET_LOCATIONS',
    CREATE_LOCATION: 'CREATE_LOCATION',
    EDIT_LOCATION: 'EDIT_LOCATION',
    DELETE_LOCATION: 'DELETE_LOCATION',

    // Regions
    GET_REGIONS: 'GET_REGIONS',
    CREATE_REGION: 'CREATE_REGION',
    EDIT_REGION: 'EDIT_REGION',
    DELETE_REGION: 'DELETE_REGION',
    SET_REGION_FLOOR_PLAN: 'SET_REGION_FLOOR_PLAN',

    // Item Types
    GET_ITEM_TYPES: 'GET_ITEM_TYPES',
    CREATE_ITEM_TYPE: 'CREATE_ITEM_TYPE',
    EDIT_ITEM_TYPE: 'EDIT_ITEM_TYPE',
    DELETE_ITEM_TYPE: 'DELETE_ITEM_TYPE',

    // Item Type Attribute
    CREATE_ITEM_TYPE_ATTRIBUTE: 'CREATE_ITEM_TYPE_ATTRIBUTE',
    EDIT_ITEM_TYPE_ATTRIBUTE: 'EDIT_ITEM_TYPE_ATTRIBUTE',
    DELETE_ITEM_TYPE_ATTRIBUTE: 'DELETE_ITEM_TYPE_ATTRIBUTE',

    // Item Tags
    GET_ITEM_TAGS: 'GET_ITEM_TAGS',
    CREATE_ITEM_TAG: 'CREATE_ITEM_TAG',
    EDIT_ITEM_TAG: 'EDIT_ITEM_TAG',
    DELETE_ITEM_TAG: 'DELETE_ITEM_TAG',

    // Price Tier
    GET_PRICE_TIERS: 'GET_PRICE_TIERS',
    SET_PRICE_TIER: 'SET_PRICE_TIER',
    DELETE_PRICE_TIER: 'DELETE_PRICE_TIER',

    // Day Schedules
    GET_DAY_SCHEDULES: 'GET_DAY_SCHEDULES',
    SET_DAY_SCHEDULE: 'SET_DAY_SCHEDULE',
    DELETE_DAY_SCHEDULE: 'DELETE_DAY_SCHEDULE',

    // Week Schedules
    GET_WEEK_SCHEDULES: 'GET_WEEK_SCHEDULES',
    SET_WEEK_SCHEDULE: 'SET_WEEK_SCHEDULE',
    DELETE_WEEK_SCHEDULE: 'DELETE_WEEK_SCHEDULE',

    // Schedule Calendar
    GET_SCHEDULE_CALENDAR: 'GET_SCHEDULE_CALENDAR',


    // Item
    GET_ITEMS: 'GET_ITEMS',
    CREATE_ITEM: 'CREATE_ITEM',
    EDIT_ITEM: 'EDIT_ITEM',
    CLONE_ITEM: 'CLONE_ITEM',
    DELETE_ITEM: 'DELETE_ITEM',

    SET_ITEM_SCHEDULE: 'SET_ITEM_SCHEDULE',

    GET_ITEM_AD_HOC_SCHEDULES: 'GET_ITEM_AD_HOC_SCHEDULES',
    SET_ITEM_AD_HOC_SCHEDULE: 'SET_ITEM_AD_HOC_SCHEDULE',
    DELETE_ITEM_AD_HOC_SCHEDULE: 'DELETE_ITEM_AD_HOC_SCHEDULE',

    REGENERATE_ITEM_SESSIONS: 'REGENERATE_ITEM_SESSIONS',

    // Facilities
    GET_FACILITIES: 'GET_FACILITIES',

    // Booking Record
    GET_BOOKING_RECORDS: 'GET_BOOKING_RECORDS',
    CREATE_BOOKING_RECORD: 'CREATE_BOOKING_RECORD',
    EDIT_BOOKING_RECORD: 'EDIT_BOOKING_RECORD',
    DELETE_BOOKING_RECORD: 'DELETE_BOOKING_RECORD',

    // Booking 
    GET_BOOKINGS: 'GET_BOOKINGS',
    CREATE_BOOKING: 'CREATE_BOOKING',
    EDIT_BOOKING: 'EDIT_BOOKING',
    CANCEL_BOOKING: 'CANCEL_BOOKING',
    SAVE_BOOKING_REMARKS: 'SAVE_BOOKING_REMARKS',
    DELETE_BOOKING: 'DELETE_BOOKING',
    APPROVE_BOOKING: 'APPROVE_BOOKING',
    DISAPPROVE_BOOKING: 'DISAPPROVE_BOOKING',

    // Session
    GET_SESSIONS: 'GET_SESSIONS',
    
    // Booking
    GET_EVENTS: 'GET_EVENTS',

    // Users
    GET_USERS: 'GET_USERS',
    SET_USER: 'SET_USER',
    LOCK_USER: 'LOCK_USER',
    UNLOCK_USER: 'UNLOCK_USER',

    // Account Groups
    GET_ACCOUNT_GROUPS: 'GET_ACCOUNT_GROUPS',
    CREATE_ACCOUNT_GROUP: 'CREATE_ACCOUNT_GROUP',
    EDIT_ACCOUNT_GROUP: 'EDIT_ACCOUNT_GROUP',
    DELETE_ACCOUNT_GROUP: 'DELETE_ACCOUNT_GROUP',

    // Approval Templates
    GET_APPROVAL_TEMPLATES: 'GET_APPROVAL_TEMPLATES',
    CREATE_APPROVAL_TEMPLATE: 'CREATE_APPROVAL_TEMPLATE',
    EDIT_APPROVAL_TEMPLATE: 'EDIT_APPROVAL_TEMPLATE',
    DELETE_APPROVAL_TEMPLATE: 'DELETE_APPROVAL_TEMPLATE',

    // Email Templates
    GET_NOTIFICATION_TEMPLATES: 'GET_NOTIFICATION_TEMPLATES',
    SET_NOTIFICATION_TEMPLATE: 'SET_NOTIFICATION_TEMPLATE',

    // Settings
    GET_ROOM_BOOKING_SETTINGS: 'GET_ROOM_BOOKING_SETTINGS',
    SET_ROOM_BOOKING_SETTINGS: 'SET_ROOM_BOOKING_SETTINGS',
    GET_EMAIL_SETTINGS: 'GET_EMAIL_SETTINGS',
    SET_EMAIL_SETTINGS: 'SET_EMAIL_SETTINGS',
    GET_TEAMNOTE_SETTINGS: 'GET_TEAMNOTE_SETTINGS',
    SET_TEAMNOTE_SETTINGS: 'SET_TEAMNOTE_SETTINGS',
}
